import { FC } from 'react';
import analytics from '@analytics/index';
import { mailto, profile } from '../services/profile';
import CookieSettingsLink from '../consent/CookieSettingsLink';
import FullCvLink from './FullCvLink';

const SiteFooter: FC = () => (
    <footer className="site-footer">
        <div className="site-footer__inner wrap">
            <span>{`© ${new Date().getFullYear()} ${profile.name}`}</span>
            <div className="site-footer__links">
                <a href={mailto}>Email</a>
                <a href={profile.siteUrl}>Site</a>
                <a
                    href={profile.linkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => analytics.trackLink(profile.linkedinUrl, 'linkedin')}
                >
                    LinkedIn
                </a>
                <FullCvLink />
                <CookieSettingsLink />
            </div>
        </div>
    </footer>
);

export default SiteFooter;
